/** @jsx jsx */
import {jsx} from 'theme-ui'
import React from 'react'
import {graphql} from 'gatsby'

import Children from '~/motion/Children'
import Layout from '~/components/layout'
import SEO from '~/components/seo'

const NotFoundPage = ({data, location}) => {
  return (
    <Layout location={location} hideFooter>
      <SEO title='404: Not Found' />
      <Children shouldAnimate>
        <div
          sx={{height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}
        >
          <h1>Page Not Found</h1>
        </div>
      </Children>
    </Layout>
  )
}

export default NotFoundPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
